window.$ = jQuery;


// WEBPACK FOOTER //
// ./wp-content/themes/obc/js/libs/globals.js